/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Origin } from './';
import {
    OriginFromJSON,
    OriginFromJSONTyped,
    OriginToJSON,
} from './';

/**
 * 
 * @export
 * @interface LanguageWithOrigin
 */
export interface LanguageWithOrigin {
    /**
     * 
     * @type {string}
     * @memberof LanguageWithOrigin
     */
    value: string;
    /**
     * 
     * @type {Origin}
     * @memberof LanguageWithOrigin
     */
    origin: Origin;
}

/**
 * Check if a given object implements the LanguageWithOrigin interface.
 */
export function instanceOfLanguageWithOrigin(value: object): value is LanguageWithOrigin {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('origin' in value) || value['origin'] === undefined) return false;
    return true;
}

export function LanguageWithOriginFromJSON(json: any): LanguageWithOrigin {
    return LanguageWithOriginFromJSONTyped(json, false);
}

export function LanguageWithOriginFromJSONTyped(json: any, ignoreDiscriminator: boolean): LanguageWithOrigin {
    if (json == null) {
        return json;
    }
    return {
        
        'value': json['value'],
        'origin': OriginFromJSON(json['origin']),
    };
}

export function LanguageWithOriginToJSON(value?: LanguageWithOrigin | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'value': value['value'],
        'origin': OriginToJSON(value['origin']),
    };
}

